import type { FunctionComponent } from "react";
import { parseAnnouncementBody } from "@/features/announce/lib/announcementBodyLinks";

interface AnnouncementBodyProps {
  readonly html: string;
}

/** 告知本文のMarkdownリンク・画像と裸URLを安全に描画する。 */
export const AnnouncementBody: FunctionComponent<AnnouncementBodyProps> = ({
  html,
}: AnnouncementBodyProps) => (
  <p className="whitespace-pre-wrap break-words leading-relaxed text-foreground">
    {parseAnnouncementBody(html).map((part) =>
      part.type === "image" ? (
        <img
          alt={part.alt}
          className="my-2 block h-auto max-w-full"
          decoding="async"
          key={part.key}
          loading="lazy"
          src={part.src}
        />
      ) : part.type === "link" ? (
        <a className="text-primary underline" href={part.href} key={part.key}>
          {part.content}
        </a>
      ) : (
        part.content
      ),
    )}
  </p>
);
